import React from "react";
import {
  Box,
  Chip,
  Col,
  FabButton,
  Flex,
  Row,
  Button,
  Typography,
} from "../../../ppui";
import { AllowanceBox } from "../../style";
import { TbAlertTriangle, TbPencil } from "react-icons/tb";
import { Icon } from "../../../ppui/icon";
import { logger } from "../../../utils/logger";

const DesignationList = ({ resource, handleClickOpen, departmentList, pagination, fetchDesignations }) => {

  // const handlePagination = (direction) => {
  //   const nextPage = direction === "next" ? pagination.page + 1 : pagination.page - 1;
  //   logger.log(direction,pagination, nextPage, "LLL" )
  //   if (nextPage > 0 && nextPage <= pagination.totalPages) {
  //     fetchDesignations(nextPage, pagination.pageSize);
  //   }
  // };

  const handlePagination = (direction) => {
    const currentPage = Number(pagination.page);
    const currentPageSize = Number(pagination.pageSize);
    const totalPages = Number(pagination.totalPages);

    const nextPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    logger.log(direction, pagination, nextPage, "LLL");

    if (nextPage > 0 && nextPage <= totalPages) {
        fetchDesignations(nextPage, currentPageSize);
    }
};


  return (
    <>
      {resource?.length > 0 ? (
        <Flex gap={20} direction={"column"}>
          {resource?.map((it, ind) => (
            <AllowanceBox key={it?.id || ind}>
              <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }}>
                <Col md={2}>
                  <Box>
                    <Box className="label">Sl. No</Box>
                    <Box className="value">{(pagination.page - 1) * pagination.pageSize + ind + 1}</Box>
                  </Box>
                </Col>
                <Col md={5} xl={3}>
                  <Box>
                    <Box className="label"> Designation Name</Box>
                    <Box className="value">{it?.designationName}</Box>
                  </Box>
                </Col>
                <Col>
                  <Box>
                    <Box className="label"> Department Name</Box>
                    <Box className="value">
                      {
                        departmentList?.filter(
                          (val) => val.id === it?.dept_id
                        )[0]?.name
                      }
                    </Box>
                  </Box>
                </Col>
                <Col>
                  <Box>
                    <Box className="label"> Status</Box>
                    <Box className="value">
                      <Chip
                        color={it?.status ? "success" : "danger"}
                        label={it?.status ? "Open" : "Close"}
                        onClick={() => {}}
                        size="sm"
                        dot
                      />
                    </Box>
                  </Box>
                </Col>
                <Col sm={"auto"}>
                  <FabButton
                    icon={<TbPencil />}
                    onClick={() => handleClickOpen(undefined, it)}
                    size="sm"
                    variant="filled"
                    shape="box"
                  />
                </Col>
              </Row>
            </AllowanceBox>
          ))}
          <Box mt={20}>
            <Flex alignItem="center" justifyContent="center" gap={10}>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page == 1}
                onClick={() => handlePagination("previous")}
              >
                Previous
              </Button>
              <Typography
                variant="body2"
                mb="0"
                color="dark"
                colorvariant="light"
              >
                Page {pagination.page} of {pagination.totalPages}
              </Typography>
              <Button
                color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page == pagination.totalPages}
                onClick={() => handlePagination("next")}
              >
                Next
              </Button>
            </Flex>
          </Box>
        </Flex>
      ) : (
        <AllowanceBox>
          <Icon color={"denger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography
            variant="body1"
            display="flex"
            gap={10}
            alignItem="center"
            mb={"0"}
            p={15}
          >
            No predefined department available.
          </Typography>
        </AllowanceBox>
      )}
    </>
  );
};

export default DesignationList;
